import React from "react";

import { CheckCircleFilled } from "@ant-design/icons";
import { toast } from "react-toastify";

import "./StyledToast.css";

const DEFAULT_BADGE_LABELS = {
  success: "Success!",
  error: "Error!",
  info: "Info",
};

const STYLED_SUCCESS_TOAST_OPTIONS = {
  icon: false,
  className: "StyledToast__Toast StyledToast__Toast--success",
  bodyClassName: "StyledToast__Body",
  closeButton: true,
  hideProgressBar: false,
  autoClose: 3500,
  style: {
    width: "100%",
    maxWidth: 374,
    minHeight: 60,
    height: "auto",
    padding: 16,
  },
};

export function StyledToastContent({ badgeLabel, message }) {
  return (
    <div className="StyledToast">
      <span className="StyledToast__Badge">
        <CheckCircleFilled className="StyledToast__Icon" aria-hidden />
        <span className="StyledToast__BadgeText">{badgeLabel}</span>
      </span>
      <span className="StyledToast__Message">{message}</span>
    </div>
  );
}

export function showStyledToast({
  variant = "success",
  message,
  badgeLabel,
  ...options
} = {}) {
  if (!message) {
    return;
  }

  if (variant === "success") {
    toast.success(
      <StyledToastContent
        badgeLabel={badgeLabel ?? DEFAULT_BADGE_LABELS.success}
        message={message}
      />,
      {
        ...STYLED_SUCCESS_TOAST_OPTIONS,
        ...options,
      },
    );
    return;
  }

  if (variant === "error") {
    toast.error(message, options);
    return;
  }

  if (variant === "info") {
    toast.info(message, options);
  }
}
